<template>
  <div class="content-editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }" ref="editor">
      <div class="menubar">

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <v-icon>format_bold</v-icon>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <v-icon>format_italic</v-icon>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <v-icon>format_strikethrough</v-icon>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <v-icon>format_underline</v-icon>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.paragraph() }"
          @click="commands.paragraph"
        >
          p
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          H2
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          H3
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <v-icon>format_list_bulleted</v-icon>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <v-icon>format_list_numbered</v-icon>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.blockquote() }"
          @click="commands.blockquote"
        >
          <v-icon>format_quote</v-icon>
        </button>

        <button
          class="menubar__button"
          @click="commands.undo"
        >
          <v-icon>undo</v-icon>
        </button>

        <button
          class="menubar__button"
          @click="commands.redo"
        >
          <v-icon>redo</v-icon>
        </button>

      </div>
    </editor-menu-bar>

    <editor-content class="editor__content" :editor="editor" />
    <v-layout row wrap class="mt-2" v-if="maxLength > 0">
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-btn depressed color="white" class="events-none" :class="{'mt-5': $vuetify.breakpoint.smAndDown, 'grey--text text--darken-2': current_length <= maxLength, 'red--text': current_length > maxLength }"><span class="mr-6">Počet znaků</span> {{current_length}}/{{maxLength}}</v-btn>
        <p v-if="current_length > maxLength" class="error--text text-right bold text-12 mt-1">Zadali jste příliš mnoho znaků!</p>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Search,
} from 'tiptap-extensions'
export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  data() {
    return {
      html: null,
      // searching: false,
      searchTerm: null,
      replaceWith: null,
      over_max_length: false,
      current_length: 0,
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Search({
            disableRegex: false,
          }),
        ],
        content: '',
        onUpdate: function (a) {
          // get new content on update
          var newContent = a.getHTML();
          this.$emit("input", newContent);
          if (this.maxLength > 0) {
            this.over_max_length = a.getHTML().replace(/<[^>]*>?/gm, '').length > this.maxLength;
          }
          this.current_length = a.getHTML().replace(/<[^>]*>?/gm, '').length;
        }.bind(this),
      }),
    }
  },
  props: {
    value: String,
    maxLength: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    console.log(this.value);
    this.$refs.editor.editor.setContent(this.value);
    this.current_length = this.value != null ? this.value.replace(/<[^>]*>?/gm, '').length : 0;
  },
  watch: {
    value (v) {
      //this.$refs.editor.editor.setContent(v);
      //this.current_length = v.replace(/<[^>]*>?/gm, '').length;
    }
  },
  methods: {
    validate () {
      return this.maxLength == 0 || this.current_length <= this.maxLength;
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ContentEditor.vue